import { Injectable, OnDestroy } from '@angular/core';
import { fromEvent, Observable, Subject, Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BarcodeListenerService implements OnDestroy {
  private readonly MAX_INTERVAL_MS = 50;
  private barcode$ = new Subject<string>();
  private buffer = '';
  private lastKeyTime = 0;
  private subscription: Subscription;

  constructor() {
    this.subscription = fromEvent<KeyboardEvent>(document, 'keydown').subscribe(event => this.onKeydown(event));
  }

  get barcodes$(): Observable<string> {
    return this.barcode$.asObservable();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private onKeydown(event: KeyboardEvent): void {
    const target = event.target as HTMLElement;
    const tag = target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target.isContentEditable) {
      return;
    }

    const now = Date.now();
    if (this.buffer.length > 0 && now - this.lastKeyTime > this.MAX_INTERVAL_MS) {
      this.buffer = '';
    }
    this.lastKeyTime = now;

    if (event.key === 'Enter') {
      if (this.buffer.length > 0) {
        this.barcode$.next(this.buffer);
        this.buffer = '';
      }
    } else if (event.key.length === 1) {
      this.buffer += event.key;
    }
  }
}
